export default __webpack_public_path__ + "static/media/shoe2.a767a8d0.jpg";